import { AppBar, Box, IconButton } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import BugReportIcon from '@mui/icons-material/BugReport';

import { useSettings } from '../../../Settings/useSettings';
import { IDeviceCompass, IMapLocationTracker } from '../../LocationInfo/types';
import { formatAltitude, formatHeading, formatSpeed } from '../../Common/Units/utils';
import { IActionForOwner } from '../../../Lib/Actions/actions';
import { ILogEntries } from '../../../Lib/Log/types';
import AttitudeItem from './AttitudeItem';
import { useAction } from '../../../Lib/Actions/useAction';
import LogViewPopup from '../../Log/LogViewerPopup';

import toolbarStyles from "../Toolbar.module.css";


interface MapTopToolBarProps {
    locationTracker: IMapLocationTracker;
    deviceCompass: IDeviceCompass,
    locationInfoAction: IActionForOwner<void, void>;
    log: ILogEntries;
}

const MapTopToolBar = (props: MapTopToolBarProps): JSX.Element => {

    const settings = useSettings();
    const headingUnit = settings.ui.headingUnit;
    const distanceUnits = settings.ui.distanceUnits;

    const location = props.locationTracker.location;
    const speedMetresPerSec = location?.speedMetresPerSec;
    const altitudeMetres = location?.altitudeMetres;
    const headingDegrees = props.deviceCompass.headingDegrees;
    const hasLocationInfo = headingDegrees || speedMetresPerSec || altitudeMetres;

    const viewLogAction = useAction<void, void>();

    return (
        <AppBar 
            position="fixed"
            color="primary"
            sx={{ top: 0, bottom: 'auto', height: '30px', pointerEvents: 'none' }}
            className={toolbarStyles.app_bar_root}
        >
            <div className={toolbarStyles.attitude_box} onClick={() => props.locationInfoAction.start()}>
                <MyLocationIcon fontSize='small'/>
                {!!hasLocationInfo &&
                    <>
                        {!!headingDegrees && <AttitudeItem label="Heading" value={formatHeading(headingDegrees, headingUnit)} />}
                        {!!speedMetresPerSec && <AttitudeItem label="Speed" value={formatSpeed(speedMetresPerSec, distanceUnits)} />}
                        {!!altitudeMetres && <AttitudeItem label="Altitude" value={formatAltitude(altitudeMetres, distanceUnits)} />}
                    </>
                }
                {!hasLocationInfo && <Box className={toolbarStyles.attitude_item}>Tap here for location information</Box>}
            </div>

            <IconButton 
                color="inherit" 
                onClick={() => viewLogAction.start()}
                sx={{ position: 'absolute', top: 0, right: 0, margin: 0, padding: .6, pointerEvents: 'all' }}
            >
                <BugReportIcon fontSize='small' />
            </IconButton>

            <LogViewPopup action={viewLogAction} log={props.log} />

        </AppBar>        
    );

};

export default MapTopToolBar;